import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BEAT_MS = 60 * 1000;
const IDLE_MS = 2 * 60 * 1000;

/**
 * Records attendance / time-on-task for students.
 * Sends one heartbeat per minute only while the tab is visible AND the student
 * interacted (mouse, keys, scroll, touch) within the last 2 minutes.
 */
export function useTimeOnTask(kind = "lesson", lessonId = null) {
  const { user } = useAuth();
  const lastActive = useRef(Date.now());

  useEffect(() => {
    if (!user || user.role !== "student") return undefined;
    const mark = () => { lastActive.current = Date.now(); };
    const evts = ["mousemove", "keydown", "scroll", "touchstart", "click"];
    evts.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const id = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastActive.current > IDLE_MS) return;
      api.post("/activity/heartbeat", { kind, lesson_id: lessonId }).catch(() => {});
    }, BEAT_MS);
    return () => {
      clearInterval(id);
      evts.forEach((e) => window.removeEventListener(e, mark));
    };
  }, [user, kind, lessonId]);
}
